import { useEffect } from 'react';

/**
 * Publishes a floating widget's rendered height (or width) (+ gap) to a root CSS variable so other
 * floating widgets can stack above it (see the --floating-* vars in index.css).
 * Pass the element (use a state-backed ref callback); the variable is removed when the
 * element goes away, so widgets fall back to their default offset.
 */
export function usePublishFloatingHeight(
  element: HTMLElement | null,
  cssVar: '--floating-banner-h' | '--floating-install-h' | '--floating-fab-w',
  gapPx: number,
  dimension: 'height' | 'width' = 'height',
): void {
  useEffect(() => {
    if (!element) return undefined;
    const root = document.documentElement;
    const publish = (): void => {
      root.style.setProperty(cssVar, `${(dimension === 'width' ? element.offsetWidth : element.offsetHeight) + gapPx}px`);
    };
    publish();
    const observer = new ResizeObserver(publish);
    observer.observe(element);
    return () => {
      observer.disconnect();
      root.style.removeProperty(cssVar);
    };
  }, [element, cssVar, gapPx, dimension]);
}
